import React from "react";
import Estabelecimento from "../../domain/Estabelecimentos.tsx";
import styles from "./StoreDetailsModal.module.scss";

type Props = {
  store: Estabelecimento;
  onSeeStore?: () => void;
  style?: React.CSSProperties;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const StoreDetailsModal: React.FC<Props> = ({ store, onSeeStore, style, onMouseEnter, onMouseLeave }) => {
  const normalizePhoto = (photo: any): string | undefined => {
    if (!photo) return undefined;
    if (typeof photo === "string") return photo.trim();
    return photo?.url || photo?.path || photo?.src || undefined;
  };

  const firstPhoto = Array.isArray(store.fotos)
    ? store.fotos.map(normalizePhoto).find(Boolean)
    : normalizePhoto(store.fotos);

  const imageUrl =
    firstPhoto || "https://via.placeholder.com/360x220?text=Sem+imagem";

  const rawCategory = (store as any).categoria;
  const categoryValues = [
    ...(typeof rawCategory === "string"
      ? [rawCategory]
      : Array.isArray(rawCategory)
      ? rawCategory
          .map((categoria: any) =>
            typeof categoria === "string" ? categoria : categoria?.nomeCategoria,
          )
          .filter(Boolean)
      : rawCategory?.nomeCategoria
      ? [rawCategory.nomeCategoria]
      : []),
    ...(Array.isArray(store.categorias)
      ? store.categorias
          .map((categoria: any) =>
            typeof categoria === "string" ? categoria : categoria?.nomeCategoria,
          )
          .filter(Boolean)
      : []),
  ];
  const categories = categoryValues
    .filter(Boolean)
    .reduce<string[]>((unique, value) => {
      if (!unique.includes(value)) unique.push(value);
      return unique;
    }, []);

  return (
    <div
      className={styles.modal}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.imageWrapper}>
        <img
          src={imageUrl}
          alt={store.nome}
          className={styles.image}
          onError={(event) => {
            const target = event.currentTarget;
            if (target.src !== "https://via.placeholder.com/360x220?text=Sem+imagem") {
              target.src = "https://via.placeholder.com/360x220?text=Sem+imagem";
            }
          }}
        />
      </div>

      <div className={styles.details}>
        <div className={styles.meta}>
          <div className={styles.categoryList}>
            {categories.length > 0 ? (
              categories.map((categoryName) => (
                <span key={categoryName} className={styles.categoryPill}>
                  {categoryName}
                </span>
              ))
            ) : (
              <span className={styles.categoryPill}>Sem categoria</span>
            )}
          </div>

          <h3 className={styles.title}>{store.nome}</h3>
          <p className={styles.description}>{store.descricao || "Descrição não disponível."}</p>
        </div>

        <button className={styles.actionButton} type="button" onClick={onSeeStore}>
          Ver estabelecimento
        </button>
      </div>
    </div>
  );
};

export default StoreDetailsModal;
